import PedidoService from '@/src/services/pedido'

const pedidoMixin = {
  data() {
    return { 
      pedidosFields: [
        {
          key: 'usuario',
          label: 'Usuário',
          class: 'size-col-20',
        },
        {
          key: 'status',
          label: 'Status',
          class: 'size-col-20',
        },
      ],
    }
  },
  methods: {
    loadPedidos() {
      return PedidoService.list()
        .then((response) => {
          return response
        })
        .catch((error) => error)
    },

    async updatePedido(id, pedido) {
      return await PedidoService.update(id, pedido)
    }
  },
}

export default pedidoMixin
